import type { ActivityType, CockpitRepRow } from '../../../types';

/**
 * The activity types that get their own column on the Team table, in display
 * order. Notes and Other stay inside the Activities total. The table, the CSV
 * export, the card view and the sort keys all read from this one list.
 */
export interface ActivityTypeColumn {
  type: ActivityType;
  label: string;
  title: string;
}

export const ACTIVITY_TYPE_COLUMNS: readonly ActivityTypeColumn[] = [
  { type: 'CALL', label: 'Calls', title: 'Calls in the period, whatever their status' },
  { type: 'TEXT', label: 'Texts', title: 'Texts in the period' },
  { type: 'EMAIL', label: 'Emails', title: 'Emails logged in the CRM plus Gmail-synced email for connected reps — both directions, counted once per CRM contact on each message' },
  { type: 'IN_PERSON', label: 'Visits', title: 'In-person meetings in the period' },
];

export type ActivityTypeSortKey = `byType.${ActivityType}`;

export const byTypeKey = (type: ActivityType): ActivityTypeSortKey => `byType.${type}`;

export function isByTypeKey(key: string): key is ActivityTypeSortKey {
  return key.startsWith('byType.');
}

export function typeOfKey(key: ActivityTypeSortKey): ActivityType {
  return key.slice('byType.'.length) as ActivityType;
}

export function typeCount(row: CockpitRepRow, type: ActivityType): number {
  return row.byType?.[type] ?? 0;
}

export function sumTypeCount(rows: CockpitRepRow[], type: ActivityType): number {
  return rows.reduce((acc, r) => acc + typeCount(r, type), 0);
}
